(function(){
  var track = document.getElementById('bshRangesTrack');
  if(!track) return;
  var btns = document.querySelectorAll('#brand-shop-head .arrow-btn');
  btns.forEach(function(b){
    b.addEventListener('click', function(){
      var dir = parseInt(b.getAttribute('data-bsh-dir'), 10) || 1;
      var card = track.querySelector('.range');
      var w = card ? (card.getBoundingClientRect().width + 18) : 320;
      track.scrollBy({ left: dir * w * 1.2, behavior: 'smooth' });
    });
  });
})();